module.exports = __webpack_public_path__ + "img/red_envelopes_bg.ec05b1b9.png";